import React, { useState, useEffect } from 'react';
import PitchbookInsights from './PitchbookInsights';
import PitchbookPrimaryContact from "./PitchbookPrimaryContact";
import { PITCHBOOK_INSIGHTS, PITCHBOOK_CONTACT_INFO } from '../../common/util/constants';
import "./investmentDetail.css";

const InvestmentDetails = ({ portfolioDetails }) => {

  const customCheckRender = (value) => {
    if (value) {
        return (
                <i className="fa-sharp fa-solid fa-square-check fa-sm check-mark"></i>
        );
    } else {
        return (
                <i className="fa-sharp fa-solid fa-circle-xmark fa-sm cross-mark"></i>
        );
    }
  };

  // Display a loading message if the details are not yet loaded.
  if (!portfolioDetails) {
    return <p>Loading...</p>;
  }

  return (
    <div className="portfolio-details">
      <p>Company Name: <span>{portfolioDetails.portfolio.company_name} ( <a href={portfolioDetails.portfolio.website_url} target="_blank" rel="noopener noreferrer">{portfolioDetails.portfolio.website_url}</a> )</span></p>
      <p>Company Legal Name: <span>{portfolioDetails.portfolio.company_legal_name}</span></p>
      <p>Pitchbook Id: <a href={`https://my.pitchbook.com/profile/${portfolioDetails.portfolio.pitchbook_id}/company/profile`} target="_blank" rel="noopener noreferrer">{portfolioDetails.portfolio.pitchbook_id}</a></p>
      {portfolioDetails.portfolioInsights && <PitchbookInsights portfolioInsights={portfolioDetails.portfolioInsights.find(insight => insight.insight_code === PITCHBOOK_INSIGHTS)} />}
      {portfolioDetails && portfolioDetails.portfolioInsights && <PitchbookPrimaryContact data={portfolioDetails.portfolioInsights.find(insight => insight.insight_code === PITCHBOOK_CONTACT_INFO)} />}
      <p>Website Blurb:</p>
      <textarea 
        readOnly 
        value={portfolioDetails.portfolio.website_blurb} 
        className="textarea-blurb" 
      />
      <p/>
      
      <p>Investment Details:</p>
      <table className="id_table">
        <thead>
          <tr>
            <th>Investment Round</th>
            <th>Investment Type</th>
            <th>Investment Amount</th>
            <th>Investment Date</th>
            <th>Fund Name</th>
            <th>Current AUM</th>
            <th>Percent Of Fund AUM</th>
          </tr>
        </thead>
        <tbody>
          {portfolioDetails.investmentDetails.map((investment, index) => {
            
            // formatting investmentAmount and currentAum as currency with 0 decimals
            const formattedInvestmentAmount = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(investment.investmentAmount);
            const formattedAUM = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(investment.currentAum);
            
            // formatting investmentDate as a date string
            const formattedInvestmentDate = new Date(investment.investmentDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
            
            // formatting percentOfFundAum as a percentage with 2 decimal places
            const formattedPercentOfFundAum = (investment.percentOfFundAum * 100).toFixed(2) + "%";
            
            return (
              <tr key={index}>
                <td>{investment.investmentRound}</td>
                <td>{investment.investmentType}</td>
                <td>{formattedInvestmentAmount}</td>
                <td>{formattedInvestmentDate}</td>
                <td>{investment.fundName}</td>
                <td>{formattedAUM}</td>
                <td>{formattedPercentOfFundAum}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <p>Show on public website: {customCheckRender(portfolioDetails.portfolio.show_on_public_website)}</p>

    </div>
  );
};

export default InvestmentDetails;
